"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "notification", {
  enumerable: true,
  get: function get() {
    return _notification["default"];
  }
});
var _notification = _interopRequireDefault(require("./notification"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }